module.exports = __webpack_public_path__ + "img/logo.1170e13f.svg";